"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postMessageApiCallFactory = exports.addPostMessageApiPromise = exports.handlePossibleResultMessage = exports.PostMessageRequestMetadataParameterNames = void 0;
const to_name_map_1 = require("./to-name-map");
const api_factory_1 = require("./api-factory");
const exceptions_1 = require("./exceptions");
const apiUrl = "https://dicekeys.app";
exports.PostMessageRequestMetadataParameterNames = (0, to_name_map_1.toFieldNameMap)("windowName");
;
/**
 * An window opened in the DiceKeys app to which we can send
 * API requests.
 *
 * Private and internal to this module to prevent rogue code form accessing it.
 */
var diceKeysAppWindow;
var resolveDiceKeysAppWindowReadyPromise;
/**
 * Map requestIds to the resolve/reject functions needed to re-start
 * resume the [[call]] function when the DiceKeys app sends the response
 * to a request.
 *
 * Private and internal to this module to prevent rogue code form accessing it.
 */
const pendingCallResolveFunctions = new Map();
/*
 * Handles calls to window.onMessage to receive responses to requests.
 */
const handlePossibleResultMessage = (result) => {
    if (result.origin.startsWith(apiUrl) && result.data === "ready") {
        resolveDiceKeysAppWindowReadyPromise === null || resolveDiceKeysAppWindowReadyPromise === void 0 ? void 0 : resolveDiceKeysAppWindowReadyPromise();
        return;
    }
    const _a = result.data, { requestId } = _a, response = __rest(_a, ["requestId"]);
    // FIXME -- validate origin is the Dicekeys app for good measure,
    // or treat the RequestId as an authentication key since it's strong enough?
    // Will do latter for now.
    if (requestId && pendingCallResolveFunctions.has(requestId)) {
        const resolveFn = pendingCallResolveFunctions.get(requestId);
        pendingCallResolveFunctions.delete(requestId);
        try {
            if ("exception" in response && typeof response.exception === "string") {
                throw (0, exceptions_1.restoreException)(response.exception, response.message, response.stack);
            }
            else {
                resolveFn.resolve(response);
            }
        }
        catch (e) {
            resolveFn.reject(e);
        }
    }
};
exports.handlePossibleResultMessage = handlePossibleResultMessage;
var alreadyListeningForResultMessages = false;
const addPostMessageApiPromise = (requestId) => new Promise((resolve, reject) => pendingCallResolveFunctions.set(requestId, { resolve, reject }));
exports.addPostMessageApiPromise = addPostMessageApiPromise;
/**
 * Transmit requests to a window running the DiceKeys app, creating that
 * window if necessary.
 */
const transmitRequest = (request) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!alreadyListeningForResultMessages) {
        // Set up the listener for the response if one is not yet running
        window.addEventListener("message", (messageEvent) => (0, exports.handlePossibleResultMessage)(messageEvent));
        alreadyListeningForResultMessages = true;
    }
    if (!diceKeysAppWindow || diceKeysAppWindow.closed) {
        const diceKeysAppWindowReadyPromise = new Promise((resolve) => { resolveDiceKeysAppWindowReadyPromise = resolve; });
        // Need to create a new window to send API requests to
        diceKeysAppWindow = (_a = window.open(apiUrl, "dicekeys-api-window")) !== null && _a !== void 0 ? _a : undefined;
        yield diceKeysAppWindowReadyPromise;
    }
    // We'll use a promise to wait for the response, storing a resolve and
    // reject function so that the [[handlePossibleResultMessage]] function can
    // find them by the requestId.
    const responseMessagePromise = (0, exports.addPostMessageApiPromise)(request.requestId);
    diceKeysAppWindow.postMessage(request, apiUrl);
    // We now await the response, which will arrive via a message event,
    // be processed by [[handlePossibleResultMessage]], which will
    // cause the promise to be resolved or rejected.
    return yield responseMessagePromise;
});
const postMessageApiCallFactory = (transmitRequestFn = transmitRequest) => (request) => __awaiter(void 0, void 0, void 0, function* () {
    if (!window.name || window.name === "view") {
        // This window needs a name so that the window we're calling can
        // refer to it by name.
        window.name = (0, api_factory_1.generateRequestId)();
    }
    // Generate a random request ID, which will be returned with the response,
    // so that we will know that response is for this request.
    const requestId = (0, api_factory_1.generateRequestId)();
    // Build a request as an object matching parameter names to
    // parameters, which can either be strings or byte arrays.
    const windowName = window.name;
    const metaParameters = {
        command: request.command,
        requestId,
        windowName,
    };
    const requestObject = Object.assign(Object.assign({}, request), metaParameters);
    // We'll now transmit the request.  We use a transmitRequest function which
    // is set by the constructor to facilitate testing.  In production, all
    // that does is call the [[defaultTransmitRequest]], which creates a window
    // for the DiceKey app if necessary and sends a postMessage to the app.
    return yield transmitRequestFn(requestObject);
});
exports.postMessageApiCallFactory = postMessageApiCallFactory;
//# sourceMappingURL=post-message-api-factory.js.map